import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';
import { saveAs } from 'file-saver-es';
import removeAccents from 'remove-accents';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import * as SINONIMOS from '../../assets/sinonimo.json';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { AnalyticsSegmentDialogComponent } from '../analytics-segment-dialog/analytics-segment-dialog.component';
import { debounceTime } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { FilterDialogComponent } from '../filter-dialog/filter-dialog.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CandidateEditDialogComponent } from '../candidate-edit-dialog/candidate-edit-dialog.component';


const EDUCATION_LABEL = {
  'ens-sup-curs': 'Cursando ensino superior',
  'ens-sup-comp': 'Ensino superior completo',
  'ens-sup-inc': 'Ensino superior incompleto',
  'none': 'Nenhum',
  'tec-med-comp': 'Ensino técnico completo',
  'tec-med-curs': 'Cursando ensino técnico',
  'tec-med-inc': 'Ensino técnico incompleto',
  'ens-med-comp': 'Ensino médio completo',
  'ens-med-curs': 'Cursando ensino médio',
  'ens-med-inc': 'Ensino medio incompleto',
  'ens-fund-comp': 'Ensino fundamental completo',
  'ens-fund-inc': 'Ensino fundamental incompleto',
  'ens-fund-curs': 'Cursando ensino fundamental',
  'ens-comp-comp': 'Ensino complementar completo',
  'ens-comp-inc': 'Ensino complementar incompleto',
  'ens-comp-curs': 'Cursando ensino complementar'
};
const FILTER_LABEL = {
  'education': 'Educação',
  'state': 'Estado',
  'gender': 'Sexo',
  'professional:professionalName': 'Setor',
  'professional:specializationName': 'Área',
  'professional:roleLevel': 'Cargo',
  'professional:branch': 'Ramo de atividade'
}
const STATES = {
  "acre": "AC",
  "alagoas": "AL",
  "amapa": "AP",
  "amazonas": "AM",
  "bahia": "BA",
  "ceara": "CE",
  "distrito federal": "DF",
  "espirito santo": "ES",
  "goias": "GO",
  "maranhao": "MA",
  "mato grosso": "MT",
  "mato grosso do sul": "MS",
  "minas gerais": "MG",
  "para": "PA",
  "paraiba": "PB",
  "parana": "PR",
  "pernambuco": "PE",
  "piaui": "PI",
  "rio de janeiro": "RJ",
  "rio grande do norte": "RN",
  "rio grande do sul": "RS",
  "rondonia": "RO",
  "roraima": "RR",
  "santa catarina": "SC",
  "sao paulo": "SP",
  "sergipe": "SE",
  "tocantins": "TO"
}

const BAR_HEIGHT = 30;

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit {

  form: FormGroup;
  charts: any = {};
  chartHeight: number = 100;
  chartWidth: number = 0;
  segments: Array<any> = [];
  submiting: boolean = false;
  submitingTable: boolean = false;
  filters: Array<any> = [];
  sinonimos: any[] = (SINONIMOS as any).default;
  filteredSinonimos: any[] = [];
  filterParams: any = {};
  datesInterval!: string;
  @ViewChild('lineChartWrapper') lineChartWrapper: ElementRef<any>;
  advCharts: any = {}
  totalCandidates: number = 0;
  displayedColumns: string[] = ['firstname', 'email', 'gender', 'birthdate', 'phone', 'address', 'state', 'city'];
  columnsDisplayName = {
    firstname: 'Nome',
    email: 'Email',
    gender: 'Gênero',
    birthdate: 'Data de nascimento',
    phone: 'Telefone',
    address: 'Endereço',
    city: 'Cidade',
    state: 'Estado'
  }
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  formDateInterval: FormGroup;

  constructor(
    fb: FormBuilder,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private change: ChangeDetectorRef,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private snackbar: MatSnackBar
  ) {

    this.form = fb.group({
      field: [null],
      segment: [null],
      office: [null],
      desiredJob: [null],
      dateStart: [null],
      dateEnd: [null]
    })

    this.filteredSinonimos = this.sinonimos
    this.formDateInterval = fb.group({
      dateStart: [null, Validators.required],
      dateEnd: [null, Validators.required],
    });

  }

  ngOnInit(): void {

    this.form.valueChanges
      .pipe(debounceTime(1000))
      .subscribe(() => {
        if (this.form.valid)
          this.getCharts()
      })
    this.getSegments();

    const subject = new Subject<any>();
    subject.subscribe(
      (result: any) => {

        const { scope, trigger } = result;

        if (scope.indexOf('analytics') > -1)
          this.submiting = trigger === 'pre';

        if (scope.indexOf('candidates') > -1)
          this.submitingTable = trigger === 'pre'

        if (this.submiting)
          this.formDateInterval.disable({ emitEvent: false });
        else this.formDateInterval.enable({ emitEvent: false });

      }
    )
    this.http.setLoadingIndicator(subject)

    const data = localStorage.getItem('filter_report');
    if (data)
      this.filterParams = JSON.parse(data);

    this.formDateInterval
      .valueChanges
      .subscribe((date) => {

        if (this.formDateInterval.valid)
          this._getAllCandidates()
      })


  }

  getFilterLabel(name: string) {
    return FILTER_LABEL[name];
  }

  getSegments(params = {}) {

    this.http.list('segment', params)
      .subscribe(
        (result: any) => {
          this.segments = result.data
        },
        err => this.errorReport.showMessage(err)
      )

  }

  public getCharts() {

    const data = this.form.getRawValue();
    const { field, segment } = data;

    if (this.form.valid) {
      if (field) {
        const [p1, p2] = field.split(':');

        if (!p2)
          this.getAnalytics(p1, { ...data, dateStart: data.dateStart, dateEnd: data.dateEnd });
        else this.getAnalyticsProfessional(p2, segment, data.desiredJob, data.dateStart, data.dateEnd);
      } else this.getAnalytics(null, { ...data, dateStart: data.dateStart, dateEnd: data.dateEnd });
    }

  }

  public getAnalytics(field: any, extraValues: any = {}) {

    this.charts = [];
    const filteredValues: any = Object.keys(extraValues)
      .filter(key => extraValues[key] !== null)
      .reduce((acc, key) => {
        acc[key] = extraValues[key];
        return acc;
      }, {});
    const data = { field, ...filteredValues }

    if (filteredValues.desiredJob)
      data['desiredJob'] = filteredValues.desiredJob.Name;

    if (filteredValues.dateStart)
      data['dateStart'] = filteredValues.dateStart.format('YYYY-MM-DD');

    if (filteredValues.dateEnd)
      data['dateEnd'] = filteredValues.dateEnd.format('YYYY-MM-DD');

    this.http.list('analytics', data)
      .subscribe(
        (result: any) => {

          if (result?.length)
            this.makeGroupChart(result);

        },
        err => this.errorReport.showMessage(err)
      );

    if (extraValues.dateStart) {
      this.http.list('analytics:candidates_by_date', data)
        .subscribe(
          (result: any) => {

            if (result?.length)
              this.makeCandidatesbyDateChart(result)

          },
          err => this.errorReport.showMessage(err)
        );

      this.http.list('analytics:process_list_by_date', data)
        .subscribe(
          (result: any) => {

            if (result?.length)
              this.makeProcessListbyDateChart(result)

          },
          err => this.errorReport.showMessage(err)
        );
    }

  }

  public getAnalyticsProfessional(field, segment, desiredJob = null, dateStart = null, dateEnd = null) {

    this.charts = [];
    const data = { field }

    if (segment)
      data['segment'] = segment;

    if (desiredJob)
      data['desiredJob'] = desiredJob.Name;

    if (dateStart)
      data['dateStart'] = dateStart.format('YYYY-MM-DD');

    if (dateEnd)
      data['dateEnd'] = dateEnd.format('YYYY-MM-DD');

    this.http.list('analytics:professional', data)
      .subscribe(
        result => {
          this.makeGroupChart(result);
        },
        err => this.errorReport.showMessage(err)
      );

  }

  private makeGroupChart(result) {

    const data = [];
    const { field } = this.form.getRawValue();

    for (const item of result) {

      const label = field === 'education' ? EDUCATION_LABEL[item.field] || null : item.field;

      data.push({
        name: (!label) || label == 'undefined' ? 'Não informado' : label,
        value: item.records
      })

    }

    this.chartHeight = data.length * BAR_HEIGHT;
    this.charts['group'] = data;
    this.change.detectChanges();

  }

  private makeCandidatesbyDateChart(result) {

    const data = [{
      name: 'Candidatos',
      series: []
    }];

    for (const item of result) {
      data[0].series.push({
        value: item.records,
        name: this.datePipe.transform(new Date(item.date_added), 'dd-MM-YYYY')
      })
    }

    this.chartHeight = 500;
    this.chartWidth = this.lineChartWrapper.nativeElement.clientWidth - 100;
    this.charts['candidatesByDate'] = data;

  }

  private makeProcessListbyDateChart(result) {

    const data = [{
      name: 'Processos Seletivos',
      series: []
    }];

    for (const item of result) {
      data[0].series.push({
        value: item.records,
        name: this.datePipe.transform(new Date(item.created_at), 'dd-MM-YYYY')
      })
    }

    this.chartHeight = 500;
    this.chartWidth = this.lineChartWrapper.nativeElement.clientWidth - 100;
    this.charts['processListByDate'] = data;

  }

  removeFilter(index) {
    this.filters.splice(index, 1);
  }

  public chooseFilter(data: any) {

    const formData = this.form.getRawValue();
    const filterName = formData.field;
    const index = this.filters.findIndex(filter => filter.value === data.name && filter.name === filterName);

    if (index > -1)
      this.filters.splice(index, 1);
    else {
      this.filters.push({
        name: filterName,
        value: data.name
      });
    }

  }

  public openSegment() {

    const filters = []

    for (const filter of this.filters) {

      let filterValue = filter.value;
      if (filter.name === 'education') {
        for (const education in EDUCATION_LABEL) {
          if (EDUCATION_LABEL[education] === filter.value)
            filterValue = education;
        }
      }

      filters.push({
        name: filter.name,
        value: filterValue
      })

    }

    const extrasFilters = {}
    const formData = this.form.getRawValue();

    if (formData.dateStart)
      extrasFilters['dateStart'] = formData.dateStart.format('YYYY-MM-DD');

    if (formData.dateEnd)
      extrasFilters['dateEnd'] = formData.dateEnd.format('YYYY-MM-DD');

    if (formData.desiredJob)
      extrasFilters['desiredJob'] = formData.desiredJob.Name;

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        filters,
        extrasFilters
      }
    };

    this.dialog.open(AnalyticsSegmentDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          if (result) {
            this.filters = [];
            this.getCharts();
          }
        }
      );

  }

  private getTotalCandidates(datesInterval: string) {

    const params: any = {
      searchs: JSON.stringify(this.filterParams),
      // onlyValidated: true
    }

    if (Object.keys(params.searchs).length == 0) {
      return;
    }

    if (datesInterval)
      params['datesInterval'] = datesInterval

    this.http.get('candidates:total', params)
      .subscribe(
        (result: any) => {

          const { records } = result;
          this.totalCandidates = parseInt(records);
        }
      )

  }

  private getGroupedCandidates(groupBy: string, datesInterval: string) {

    const params: any = {
      searchs: JSON.stringify(this.filterParams),
      groupBy
    }

    if (datesInterval)
      params['datesInterval'] = datesInterval

    this.http.get('analytics:total', params)
      .subscribe(
        (result: any) => {

          if (!result) {
            this.advCharts = {}
            this.dataSource.data = []
            return;
          }

          switch (groupBy) {
            case 'age': {

              const container = document.querySelector('#ageChartContainer');
              const containerWidth = result?.length * 30 + 100;

              this.advCharts[groupBy] = {
                view: [
                  containerWidth,
                  container.clientHeight - 150,
                ],
                total: result?.length,
                undefined: result.filter((row: any) => row.age.trim().length === 0).map(a => parseInt(a.records)).reduce((a, b) => a + b, 0),
                data: result.filter((row: any) => row.age.trim().length > 0)
                  .map((row: any) => ({
                    name: row.age,
                    value: parseInt(row.records)
                  }))
              };

            }; break;
            case 'gender': {
              const container = document.querySelector('#genderChartContainer');

              this.advCharts[groupBy] = {
                view: [
                  container.clientWidth - 150,
                  container.clientHeight - 150
                ],
                total: result?.length,
                undefined: result.filter((row: any) => row.gender.trim().length === 0).map(a => parseInt(a.records)).reduce((a, b) => a + b, 0),
                data: result.filter((row: any) => row.gender.trim().length > 0)
                  .map((row: any) => ({
                    name: (row.gender.trim().length == 0) ? 'Não definido' : row.gender,
                    value: parseInt(row.records)
                  }))
              };

            }; break;
            case 'state': {
              const container = document.querySelector('#stateChartContainer');
              const containerHeight = result?.length * 30 + 100;

              this.advCharts[groupBy] = {
                view: [
                  container.clientWidth - 100,
                  containerHeight,
                ],
                total: result?.length,
                undefined: result.filter((row: any) => row.state.trim().length === 0).map(a => parseInt(a.records)).reduce((a, b) => a + b, 0),
                data: result.filter((row: any) => row.state.trim().length > 0)
                  .map((row: any) => {
                    let [name, sigla] = row.state.split(',');

                    if (name.trim().length == 2)
                      sigla = name.toUpperCase();
                    else if (!sigla) {
                      const fname = removeAccents(name).trim().toLowerCase();
                      sigla = STATES[fname]
                    }

                    return {
                      name: (row.state.trim().length == 0) ? 'Não definido' : sigla,
                      value: parseInt(row.records)
                    }
                  })
              };
            }; break;
            case 'sinonimo': {
              const container = document.querySelector('#sinonimoChartContainer');
              const containerHeight = result?.length * 30 + 100;

              this.advCharts[groupBy] = {
                view: [
                  container.clientWidth - 100,
                  containerHeight,
                ],
                total: result?.length,
                undefined: result.filter((row: any) => row.sinonimo.trim().length === 0).map(a => parseInt(a.records)).reduce((a, b) => a + b, 0),
                data: result.filter((row: any) => row.sinonimo.trim().length > 0)
                  .map((row: any) => ({
                    name: (row.sinonimo.trim().length == 0) ? 'Não definido' : row.sinonimo,
                    value: parseInt(row.records)
                  }))
              };
            }; break;
            case 'city': {
              const container = document.querySelector('#cityChartContainer');
              const containerWidth = result?.length * 30 + 100;

              this.advCharts[groupBy] = {
                view: [
                  containerWidth,
                  container.clientHeight - 150
                ],
                total: result?.length,
                undefined: result.filter((row: any) => row.city.trim().length === 0).map(a => parseInt(a.records)).reduce((a, b) => a + b, 0),
                data: result.filter((row: any) => row.city.trim().length > 0)
                  .map((row: any) => ({
                    name: (row.city.trim().length == 0) ? 'Não definido' : row.city,
                    value: parseInt(row.records)
                  }))
              };
            }; break;
          }

        }
      )
  }

  private _getAllCandidates() {

    // let datesInterval = '';
    if (this.formDateInterval.valid) {
      const { dateStart, dateEnd } = this.formDateInterval.getRawValue();
      if (dateStart)
        this.datesInterval = `${dateStart.format('YYYY-MM-DD')}:${dateEnd.format('YYYY-MM-DD')}`;
    }

    this.getTotalCandidates(this.datesInterval);
    this.getGroupedCandidates('age', this.datesInterval);
    this.getGroupedCandidates('gender', this.datesInterval);
    this.getGroupedCandidates('state', this.datesInterval);
    this.getGroupedCandidates('city', this.datesInterval);
    this.getGroupedCandidates('sinonimo', this.datesInterval);

    const params: any = {
      searchs: JSON.stringify(this.filterParams)
    }

    if (this.datesInterval)
      params['datesInterval'] = this.datesInterval

    this.getCandidates(0, 20, params);
  }

  public openFilterDialog() {

    const options = {
      width: '800px',
      data: {
        filter: this.filterParams
      }
    }
    this.dialog.open(FilterDialogComponent, options)
      .afterClosed()
      .subscribe(
        (result) => {

          if (result) {

            if (Object.keys(result).length === 0)
              return;

            this.formDateInterval.reset();

            result['stateInitials'] = '';
            result['stateName'] = '';

            if (result.state) {
              result['stateInitials'] = result.state.sigla;
              result['stateName'] = result.state.nome;
            }

            delete result.state;
            this.filterParams = result;
            this._getAllCandidates();
            localStorage.setItem('filter_report', JSON.stringify(this.filterParams));
          }
        }
      );

  }

  clearFilters() {

    this.filterParams = {};
    localStorage.removeItem('filter_report');
    this.advCharts = {};
    this.totalCandidates = 0;
    this.dataSource.data = [];
    this.formDateInterval.reset();

  }

  hasFilter() {
    return Object.keys(this.filterParams).length > 0;
  }

  onSelectTab(event: MatTabChangeEvent) {
    if (event.index == 1) {
      if (Object.keys(this.filterParams).length)
        this._getAllCandidates();
    }
  }

  getCandidates(page = 0, limit = 20, params) {

    this.http.list('candidates', { ...params, page, limit })
      .subscribe(
        (results: any) => {

          this.dataSource.data = []
          if (results) {

            let data = [];
            for (let result of results) {

              data.push({
                id: result.id,
                firstname: result.firstname,
                email: result.email,
                gender: result.gender,
                birthdate: result.birthdate,
                phone: result.phone,
                address: `${result.address1}, ${result.address2} - ${result.district}`,
                city: result.city,
                state: result.state
              });

            }

            this.dataSource.data = data;
          }

        },
        err => this.errorReport.showMessage(err)
      )

  }

  getCandidatesReport(page = 0, limit = 20, params) {

    this.snackbar.open('Seu relatório começou a ser gerado, isso pode demorar um pouco', 'OK', { duration: 5000 });

    this.http.list('candidates:report', { ...params, page, limit })
      .subscribe(
        (results: any) => {

          if (results) {

            let data = [];
            for (let result of results) {

              data.push({
                id: result.id,
                firstname: result.firstname,
                email: result.email,
                gender: result.gender,
                birthdate: result.birthdate,
                phone: result.phone,
                address: `${result.address1}, ${result.address2} - ${result.district}`,
                city: result.city,
                state: result.state,
                experiences: result.experiences
              });

            }

            const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Tabela');

            const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob: Blob = new Blob([wbout], { type: 'application/octet-stream' });

            saveAs(blob, 'Report.xlsx');

          }
        },
        err => this.errorReport.showMessage(err)
      )

  };

  onPageChange(args: PageEvent) {

    const { pageIndex, pageSize } = this.paginator;
    let params = {
      searchs: JSON.stringify(this.filterParams),
      datesInterval: this.datesInterval
    }

    this.getCandidates(pageIndex, pageSize, params);

  }

  resetFormDateInterval() {
    this.formDateInterval.reset();
    this.datesInterval = null
    this.advCharts = {}
    this.totalCandidates = 0;

    if (Object.keys(this.filterParams).length > 1)
      this._getAllCandidates();

  }

  exportData() {

    let params = {
      searchs: JSON.stringify(this.filterParams)
    }
    this.getCandidatesReport(0, this.totalCandidates, params);
  }

  openCandidateInfo(candidate) {
    const options = {
      width: '800px',
      disableClose: true,
      data: {
        candidate,
        readOnly: true
      }
    }
    this.dialog.open(CandidateEditDialogComponent, options);
  }

}